import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrgScreen } from '@/features/hr-org/org-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the org chart, following `routes/_authenticated/users.tsx`.
 *
 * The route sits under `_authenticated` so the layout's `beforeLoad` guard has
 * resolved the session before the screen mounts.
 *
 * The grant guard is presentation only. The API enforces `employee.view` on
 * every org endpoint and the module gate refuses the whole `/api/hr` prefix for
 * a group whose plan does not include HR, so a stale grant still 403s
 * server-side; this only keeps a user without the grant out of a screen they
 * cannot use.
 *
 * `employee.view` and not an `org.*` key: the catalogue has none. The org view
 * is a way of looking at employees, which is what the module rail's own docblock
 * says about this destination.
 *
 * Per the route-shell rule in `apps/company/AGENTS.md`, this file is a route
 * definition, a guard and a render. The screen lives in `src/features/hr-org/`.
 */
export const Route = createFileRoute('/_authenticated/hr/org')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'employee.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: OrgScreen,
})
